import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'

/**
 * Hook that determines whether properties should be hidden based on workspace type.
 * Returns true when the workspace is a virtual marketer.
 */
export const useHideProperties = (): boolean => {
  const isVirtualMarketer = useIsVirtualMarketer()

  return !!isVirtualMarketer
}
